import ArvexisPresence from '../components/ArvexisPresence';
import OnboardingScene from './OnboardingScene';
import { OnbBody, OnbButton, OnbEyebrow, OnbHeadline } from './OnboardingType';

// Screen 1 — Welcome. Warm arrival, Presence restrained, no feature explanation.
export const StepWelcome = ({ copy: COPY, onContinue }) => (
  <OnboardingScene
    step={1}
    copy={COPY}
    align="center"
    desktopAlign="end"
    objectClass="object-center"
    footer={
      <OnbButton onClick={onContinue} testId="onboarding-continue-btn-1">
        {COPY.continue}
      </OnbButton>
    }
  >
    <div className="mb-10 ml-[42%] opacity-80 lg:mb-20 lg:ml-[18%] lg:origin-bottom-left lg:scale-[1.6]">
      <ArvexisPresence size="small" state="idle" />
    </div>

    <div className="max-w-[20rem] lg:max-w-[46rem]">
      <OnbEyebrow testId="onboarding-eyebrow-1" tight={COPY.tightEyebrow}>{COPY.welcome.eyebrow}</OnbEyebrow>
      <OnbHeadline testId="onboarding-headline-1">{COPY.welcome.headline}</OnbHeadline>

      <div className="mt-6 lg:mt-9 space-y-1.5 lg:space-y-2">
        {COPY.welcome.body.map((line) => (
          <OnbBody key={line}>{line}</OnbBody>
        ))}
      </div>
    </div>
  </OnboardingScene>
);

export default StepWelcome;
